var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/extenders/load-more-products.js
var LoadMoreProducts = class extends HTMLElement {
  constructor() {
    super();
    __publicField(this, "handleLoadMoreProducts", async (event) => {
      event.preventDefault();
      this.loadMoreButtonElement.setAttribute("aria-busy", "true");
      const sectionId = this.loadMoreButtonElement.getAttribute("data-section-id");
      const nextPage = this.loadMoreButtonElement.getAttribute("data-next-page");
      const newUrl = new URL(window.location);
      newUrl.searchParams.set("section_id", sectionId);
      newUrl.searchParams.set("page", nextPage);
      try {
        const responseData = await fetch(newUrl.toString(), {
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            "X-Requested-With": "xmlhttprequest"
          }
        }).then((r) => r.text());
        const html = new DOMParser().parseFromString(responseData, "text/html");
        const oldProducts = this.collectionProductsElement;
        const newProducts = html.querySelector("#CollectionProducts");
        const allNewProducts = newProducts.querySelectorAll("product-button");
        if (oldProducts && newProducts) {
          allNewProducts.forEach((product) => {
            oldProducts.insertAdjacentElement("beforeend", product);
          });
        }
        const oldLoadMoreButton = this.loadMoreProductsElement;
        const newLoadMoreButton = html.querySelector("load-more-products");
        if (oldLoadMoreButton && newLoadMoreButton) {
          oldLoadMoreButton.replaceWith(newLoadMoreButton);
        }
        if (responseData.errors) {
          console.log("error");
          console.log(responseData.errors);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loadMoreButtonElement.setAttribute("aria-busy", "false");
      }
    });
    this.loadMoreProductsElement = this;
    this.loadMoreButtonElement = this.loadMoreProductsElement.querySelector("[data-load-more-products]");
    this.loadMoreButtonElement.addEventListener("click", this.handleLoadMoreProducts, true, { passive: false });
    this.sectionId = this.loadMoreButtonElement.getAttribute("data-section-id");
    this.collectionProductsElement = document.querySelector("#CollectionProducts");
  }
};
if (customElements.get("load-more-products") === void 0) {
  customElements.define("load-more-products", LoadMoreProducts);
}
